import axios from "axios";
import { fetchCsrfToken, postData } from "../utils/api";

/**
 * Gửi câu hỏi tới chatbot Quantera
 */
export async function sendChatMessage({ message, locale, sessionId, lastBotAnswer }) {
  await fetchCsrfToken("/api/chat");
  const response = await postData("/api/chat", {
    message,
    locale,
    sessionId,
    lastBotAnswer: lastBotAnswer || null,
  });
  return response?.data;
}

/**
 * Lấy hoặc tạo sessionId cho hội thoại
 */
export function getOrCreateSessionId() {
  const key = "quantera_chat_session";
  let sessionId = sessionStorage.getItem(key);
  if (!sessionId) {
    sessionId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `sess-${Date.now()}`;
    sessionStorage.setItem(key, sessionId);
  }
  return sessionId;
}
